import icon1 from '../images/icon1.png'
import icon2 from '../images/icon2.png'
import icon3 from '../images/icon3.png'
export const hero = {
    title:'The Best & Simple way to run your online shop. ',
    contetnt:'Everything you need in a cloud-based, tablet-friendly platform that is expertly built for the modern age',
}
export const features =[
    {
        img:icon1,
        title:'Support Service ',
        content:"Real-time dashboards and reports help you better understand what's happening with your business. Track profitability. technician ",
        key:1
    },
    {
        img:icon2,
        title:'Built-In Communication Tools ',
        content:"Use built-in tools to communicate with customers via text and email. Send automated appointment confirmations & reminders, share invoices,",
        key:2
    },
    {
        img:icon3,
        title:'All In-One Management ',
        content:"Our web-based platform puts running every aspect of your shop in one place. Save time with job templates, inventory management,",
        key:3
    }
]
export const whyus = {
    title:'See why shops choose Go Market',
    contetnt:"We're here to help you get started, migrate your existing data, and answer questions with chat, email or phone. We protect your information with full database encryption and automatic backups.",
}
export const pricing = {
    title:'Inspections, CRM, Texting, Workflow and much more ',
    contetnt:"Real-time dashboards and reports help you better understand what's happening with your business, Track profitability, technician efficiency, customer aging, fleet performance and more. We protect your information with full database encryption and automatic backups.",
}
export const aboutus = {
    title:'Success Stories',
    contetnt:"Have you made friends while reading books with Booklove? We would love to hear your story.",
}
export const questions = {
    title:'Frequently Asked Questions ',
    contetnt:"We're here to help you get started, migrate your existing data, and answer questions with chat, email or phone. We protect your information with full database encryption and automatic backups.",
    list1:[
        {
            title:'What happens if i upgrade my subscription?',
            content:'Yes, Unamo allows for you to decide which tools are most important to you now. As your team grows or priorities change, you can always subscribe to more products. You can subscribe to a chosen product within the pricing & Products section of your Account Settings.',
            key:1,
        },
        {
            title:'Will you charge my card before my trial period is finished?',
            content:'Yes, Unamo allows for you to decide which tools are most important to you now. As your team grows or priorities change, you can always subscribe to more products. You can subscribe to a chosen product within the pricing & Products section of your Account Settings.',
            key:2,
        },
        {
            title:'How can i cancel my subscription?',
            content:'Yes, Unamo allows for you to decide which tools are most important to you now. As your team grows or priorities change, you can always subscribe to more products. You can subscribe to a chosen product within the pricing & Products section of your Account Settings.',
            key:3,
        },
        {
            title:'My free trial expire, may i test the tool again?',
            content:'Yes, Unamo allows for you to decide which tools are most important to you now. As your team grows or priorities change, you can always subscribe to more products. You can subscribe to a chosen product within the pricing & Products section of your Account Settings.',
            key:4,
        }
    ],
    list2:[
        {
            title:'Can i subscribe to only one product?',
            content:'Yes, Unamo allows for you to decide which tools are most important to you now. As your team grows or priorities change, you can always subscribe to more products. You can subscribe to a chosen product within the pricing & Products section of your Account Settings.',
            key:1,
        },
        {
            title:'Can i try tool before purchasing it?',
            content:'Yes, Unamo allows for you to decide which tools are most important to you now. As your team grows or priorities change, you can always subscribe to more products. You can subscribe to a chosen product within the pricing & Products section of your Account Settings.',
            key:2,
        }
    ]
}